// GENERATED by npm run generate-graphql-operations
const GetStationCurator = 'query GetStationCuratorWeb($pandoraId: String!) {   entity(id: $pandoraId) {     ... on StationFactory {       curator {         id         name         shareableUrlPath: urlPath         artist {           id           shareableUrlPath: urlPath         }       }     }   } } ';
export default GetStationCurator;
